import Swiper, { Autoplay, Navigation } from 'swiper';

function throttle(func, delay) {
  let timer = null;
  return function () {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, arguments);
        timer = null;
      }, delay);
    }
  };
}

let filtersSwiperWr = document.querySelectorAll('.filters-swiper-wr');
filtersSwiperWr.forEach((el) => {
  if (!el) return;

  let swiperEl = el.querySelector('.swiper');
  let swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation],
    observer: true,
    observeParents: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    threshold: 10,
    swipeToSlide: true,
    normalizeSlideIndex: false,
  });

  const slidesOverflow = () => {
    const containerWidth = swiper.el.offsetWidth;
    let slidesWidth = 0;
    swiper.slides.forEach((slide) => {
      slidesWidth += slide.offsetWidth;
    });
    return slidesWidth > containerWidth;
  };

  const scrollSlideIntoView = (index) => {
    if (!slidesOverflow()) return;

    const slide = swiper.slides[index];
    if (!slide) return;

    const containerWidth = swiper.el.offsetWidth;
    const currentTranslate = swiper.translate;
    const slideLeft = slide.offsetLeft;
    const slideRight = slideLeft + slide.offsetWidth;

    const visibleLeft = -currentTranslate;
    const visibleRight = visibleLeft + containerWidth;

    if (slideLeft >= visibleLeft && slideRight <= visibleRight) return;

    let newTranslate;
    if (slideLeft < visibleLeft) {
      newTranslate = -slideLeft + 16;
    } else {
      newTranslate = -(slideRight - containerWidth + 16);
    }

    const minT = swiper.minTranslate();
    const maxT = swiper.maxTranslate();
    newTranslate = Math.min(maxT, Math.max(minT, newTranslate));

    swiper.translateTo(newTranslate, 300);
  };

  let filterBtns = el.querySelectorAll('.filters-slider__btn');
  filterBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-active')) return;

      filterBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      scrollSlideIntoView(index);
    });
  });

  const checkEdge = () => {
    if (window.innerWidth <= 768) {
      let rect = el.getBoundingClientRect();
      let distance = Math.abs(window.innerWidth - rect.right);
      if (distance <= 2) {
        el.classList.add('is-right-edge');
      } else {
        el.classList.remove('is-right-edge');
      }
    } else {
      el.classList.remove('is-right-edge');
    }
  };

  const throttledCheck = throttle(checkEdge, 100);
  window.addEventListener('resize', throttledCheck);
  checkEdge();
});